/* eslint-disable import/no-default-export, import/order, max-lines, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
// @ts-ignore TS(6133): 'React' is declared but its value is never read.
import { cn } from "tailwind-variants";
import Loader from "common/vue/components/Loader.react.vue";
import { useDtfStore } from "./store";
import "./ArtworkHistoryModalFooter.scss";

export default function ArtworkHistoryModalFooter({
  count,
  isLoadingCta,
  ctaText,
  onClose,
  onCtaAction,
  ...restProps
}: any) {
  const store = useDtfStore();

  function isStandardArtwork() {
    // @ts-ignore TS(4111): Property 'isStandardArtwork' comes from an index s... Remove this comment to see the full error message
    return store.isStandardArtwork;
  }

  return (
    <div
      {...restProps}
      className={cn("artwork-history-footer scope-18004666", restProps.className)}
    >
      <span className="artwork-history-footer__count scope-18004666">{count}</span>
      <div className="artwork-history-footer__button-container scope-18004666">
        <button
          className={cn(
            "artwork-history-footer__button artwork-history-footer__button--secondary scope-18004666",
            {
              "artwork-history-footer__button--standard-artwork": isStandardArtwork()
            }
          )}
          type="button"
          onClick={onClose}
          data-testid="artwork-history-footer-button"
        >
          {" "}
          Cancel{" "}
        </button>
        <button
          className={cn(
            "artwork-history-footer__button artwork-history-footer__button--primary scope-18004666",
            {
              "artwork-history-footer__button--loading": isLoadingCta,
              "artwork-history-footer__button--standard-artwork": isStandardArtwork()
            }
          )}
          type="button"
          disabled={isLoadingCta}
          onClick={onCtaAction}
          data-testid="artwork-history-footer-button-1"
        >
          {ctaText}{" "}
          {isLoadingCta ? (
            <Loader
              className="artwork-history-footer__loader scope-18004666"
              data-testid="artwork-history-footer-loader"
            />
          ) : null}
        </button>
      </div>
    </div>
  );
}
